export const buildRestoredQuestionState = (question, timestamp = Date.now()) => {
  const normalized = typeof question === 'string' ? question.trim() : '';
  const history = normalized ? [{ content: normalized, timestamp }] : [];
  return {
    updatedQuestion: normalized,
    hasUpdatedQuestion: Boolean(normalized),
    updatedQuestionHistory: history,
    questionHistoryViewIndex: history.length > 0 ? history.length - 1 : 0,
  };
};

const normalizeQuestion = (question) => (
  typeof question === 'string' ? question.trim() : ''
);

export const formatChatQuestionSummary = (question) => {
  const text = normalizeQuestion(question);
  const originalInputIndex = text.indexOf('\n\n사용자가 직접 입력한 내용:\n');
  return originalInputIndex > 0 ? text.slice(0, originalInputIndex).trim() : text;
};

export const resolveChatDisplayQuestion = ({
  serverQuestion = '',
  updatedQuestion = '',
  updatedQuestionHistory = [],
  questionHistoryViewIndex = 0,
  chatHistory = [],
} = {}) => {
  const normalizedServerQuestion = normalizeQuestion(serverQuestion);
  if (normalizedServerQuestion) return normalizedServerQuestion;

  if (Array.isArray(updatedQuestionHistory) && updatedQuestionHistory.length > 0) {
    const safeIndex = Math.min(
      Math.max(0, Number(questionHistoryViewIndex) || 0),
      updatedQuestionHistory.length - 1,
    );
    const historyQuestion = normalizeQuestion(updatedQuestionHistory[safeIndex]?.content);
    if (historyQuestion) return historyQuestion;
  }

  const normalizedUpdatedQuestion = normalizeQuestion(updatedQuestion);
  if (normalizedUpdatedQuestion) return normalizedUpdatedQuestion;

  if (!Array.isArray(chatHistory)) return '';
  return chatHistory
    .filter((message) => message?.type === 'user')
    .map((message) => normalizeQuestion(message?.content))
    .filter(Boolean)
    .join(' ');
};

export const buildChatErrorSearchQuestion = (state = {}, serverQuestion = '') => {
  const normalizedServerQuestion = normalizeQuestion(serverQuestion);
  if (normalizedServerQuestion) return normalizedServerQuestion;

  const baseQuestion = resolveChatDisplayQuestion(state);
  const userMessages = Array.isArray(state.chatHistory)
    ? state.chatHistory
      .filter((message) => message?.type === 'user')
      .map((message) => normalizeQuestion(message?.content))
      .filter(Boolean)
    : [];
  const currentAnswer = userMessages[userMessages.length - 1] || '';

  if (!baseQuestion) return userMessages.join(' ');
  if (!currentAnswer || baseQuestion.includes(currentAnswer)) return baseQuestion;
  return `${baseQuestion} ${currentAnswer}`;
};
